import AssetTypeSelector from './AssetTypeSelector';

export default AssetTypeSelector;
